module.exports = __webpack_public_path__ + "assets/img/Alibaba.fa159426.svg";